module.exports = __webpack_public_path__ + "661dfcec83cf6edd5b259e60f56fef1a.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_r_40.mp3
// module id = 423
// module chunks = 0